export const formatNumber = (value: number | null | undefined, digits = 3) => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return "—";
  }
  return value.toFixed(digits);
};
